import { render, staticRenderFns } from "./SithMesInventoryStockMovementList.vue?vue&type=template&id=22aef222&"
import script from "./SithMesInventoryStockMovementList.vue?vue&type=script&lang=js&"
export * from "./SithMesInventoryStockMovementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports